import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledContainer = styled.div`
  ${({ theme }) => `
        display: flex;
        height: ${utils.rem(theme.Spacing.Size.SmallMedium)};
        padding: ${utils.rem(theme.Border.Size.Large)} ${utils.rem(theme.Spacing.Size.XSmall)};
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: ${utils.rem(theme.Border.Radius.Large)};
        background-color: ${theme.Color.NeutralsFixed.Gray};
        position: absolute;
        right: ${utils.rem(theme.Border.Size.Small)};
        bottom: ${utils.rem(theme.Border.Size.Small)};
    `}
`;
